import React, { useState, useEffect, useMemo } from "react";
import "./index.css";
import Header from "../../Component/Header";
import { useNavigate } from "react-router";
import { Col, Container, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import chartLine1 from "../../Asset/Images/chart-wave-line.png";
import chartLine2 from "../../Asset/Images/chart-wave-line2.png";
import chartLine3 from "../../Asset/Images/chart-wave-line3.png";
import FullScreenLoader from "../../Component/Loader";
import editIcon from "../../Asset/Images/edit-icon.svg";
import { getShipmetList } from "../../Services/deploy";
import MobileFooter from "../../Component/MobileFooter";

import moment from "moment";

function Home() {
  const navigate = useNavigate();
  const [listData, setListData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "ascending",
  });
  const [filters, setFilters] = useState({
    Company: "",
    DriverName: "",
    RequestType: "",
    Status: "",
    BOL: "",
    ModifiedByUser: "",
    LastUpdated: "",
    Sender: "",
    JobSiteNumber: "",
    Region: ""
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  const handleFilterChange = (e, key) => {
    console.log("e", e, key)
    setFilters((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortArrow = (key) => {
    const isActive = sortConfig.key === key;
    const isAscending = sortConfig.direction === 'ascending';

    return (
      <span style={{ fontSize: '0.75rem', marginLeft: '4px' }}>
        <span style={{ color: isActive && isAscending ? '#000' : '#ccc', cursor: 'pointer' }}>▲</span>
        <span style={{ color: isActive && !isAscending ? '#000' : '#ccc', marginLeft: '2px', cursor: 'pointer' }}>▼</span>
      </span>
    );
  };


  const filteredAndSortedData = useMemo(() => {
    if (!listData?.RequestDetails) return [];

    let filtered = listData.RequestDetails.filter((item) => {
      return (
        item.Sender?.toLowerCase().includes(filters.Sender.toLowerCase()) &&
        item.JobSiteNumber?.toLowerCase().includes(filters.JobSiteNumber.toLowerCase()) &&
        item.Region?.toLowerCase().includes(filters.Region.toLowerCase()) &&

        item.Company?.toLowerCase().includes(filters.Company.toLowerCase()) &&
        item.DriverName?.toLowerCase().includes(
          filters.DriverName.toLowerCase()
        ) &&
        item.RequestType?.toLowerCase().includes(
          filters.RequestType.toLowerCase()
        ) &&
        item.Status?.toLowerCase().includes(filters.Status.toLowerCase()) &&
        item.BOL?.toLowerCase().includes(filters.BOL.toLowerCase()) &&
        item.ModifiedByUser?.toLowerCase().includes(
          filters.ModifiedByUser.toLowerCase()
        ) &&
        item.LastUpdated?.toLowerCase().includes(
          filters.LastUpdated.toLowerCase()
        )
      );
    });

    if (sortConfig.key) {
      filtered.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        if (!aVal) return 1;
        if (!bVal) return -1;

        if (sortConfig.key === "LastUpdated") {
          aVal = new Date(aVal);
          bVal = new Date(bVal);
        }

        if (typeof aVal === "string") {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }

        return sortConfig.direction === "ascending"
          ? aVal > bVal
            ? 1
            : -1
          : aVal < bVal
            ? 1
            : -1;
      });
    }

    return filtered;
  }, [listData?.RequestDetails, filters, sortConfig]);
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredAndSortedData.slice(startIndex, endIndex);
  }, [filteredAndSortedData, currentPage]);



  const totalPages = Math.ceil(filteredAndSortedData.length / itemsPerPage);

  useEffect(() => {
    getListData();
  }, []);

  let getListData = async () => {
    setIsLoading(true);
    let res = await getShipmetList(localStorage.access_token);
    setIsLoading(false);
    if (res && res.data) {
      setListData(res.data);
    }
  };

  let getTemplateName = (template) => {
    let templateName;
    switch (template) {
      case "RELEASE":
        templateName = "release";
        break;
      case "DEPLOY":
        templateName = "deploy";
        break;
      case "STATUS_CHANGE":
        templateName = "status";
        break;
      case "RESUPPLY":
        templateName = "resupply";
        break;
      case "SWAP":
        templateName = "swap";
        break;
      case "RETURN":
        templateName = "return";
        break;
      case "ADD":
        templateName = "add";
        break;
      default:
        templateName = "deploy";
        break;
    }
    return templateName;
  }



  let handleRowClick = (val) => {
    let temp = getTemplateName(val.RequestType)
    navigate(`/template/${temp}/${val.RequestID}`)
  }

  return (
    <div className="wrapper">
      {isLoading ? <FullScreenLoader></FullScreenLoader> : null}
      <Header />
      <div className="container-layout">
        <div className="heading-section">
          <Container fluid>
            <Row>
              <Col xs="12">
                <h2 className="main-title-h">Overview </h2>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="overview-card">
          <Container fluid>
            <Row>
              <Col xs={12} md={4}>
                <div className="card-box-overview">
                  <div className="d-flex align-items-center justify-content-between card-info-overview">
                    <div className="wgt-lefthead">
                      <h3 className="text-title-over">Total</h3>
                      <h4 className="txt-info-over">Mail</h4>
                    </div>
                    <div className="count-right">
                      <span className="count-total-wt">
                        {listData.TotalMail ? listData.TotalMail : ""}
                      </span>
                    </div>
                  </div>
                  <div className="wave-line-chart">
                    <img src={chartLine1} alt="" />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div className="card-box-overview">
                  <div className="d-flex align-items-center justify-content-between card-info-overview">
                    <div className="wgt-lefthead">
                      <h3 className="text-title-over">Request Submitted</h3>
                      <h4 className="txt-info-over">Mail</h4>
                    </div>
                    <div className="count-right">
                      <span className="count-total-wt">
                        {listData.RequestMail ? listData.RequestMail : ""}
                      </span>
                    </div>
                  </div>
                  <div className="wave-line-chart">
                    <img src={chartLine2} alt="" />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div className="card-box-overview">
                  <div className="d-flex align-items-center justify-content-between card-info-overview">
                    <div className="wgt-lefthead">
                      <h3 className="text-title-over">Completed</h3>
                      <h4 className="txt-info-over">Mail</h4>
                    </div>
                    <div className="count-right">
                      <span className="count-total-wt">
                        {listData.SubmitMail ? listData.SubmitMail : ""}
                      </span>
                    </div>
                  </div>
                  <div className="wave-line-chart">
                    <img src={chartLine3} alt="" />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="list-table-overall">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="table-wapper-area mb-5">
                  <Table responsive className="table-chat-list mb-0">
                    <thead className="thead-card">
                      {/* Sorting Header Row */}
                      <tr>
                        <th onClick={() => requestSort("Sender")}>
                          Created By {getSortArrow("Sender")}
                        </th>
                        <th onClick={() => requestSort("JobSiteNumber")}>
                          RIG#{getSortArrow("JobSiteNumber")}
                        </th>
                        <th onClick={() => requestSort("Region")}>
                          REGION{getSortArrow("Region")}
                        </th>
                        <th onClick={() => requestSort("Company")}>
                          Company {getSortArrow("Company")}
                        </th>
                        {/* <th onClick={() => requestSort("DriverName")}>
                          Driver {getSortArrow("DriverName")}
                        </th> */}
                        <th>Template </th>
                        <th onClick={() => requestSort("BOL")}>
                          BOL#{getSortArrow("BOL")}
                        </th>
                        {/* <th onClick={() => requestSort("ModifiedByUser")}>
                          Created By{getSortArrow("ModifiedByUser")}
                        </th> */}
                        <th onClick={() => requestSort("LastUpdated")}>
                          Created Date{getSortArrow("LastUpdated")}
                        </th>
                        <th
                          className="text-center"
                          onClick={() => requestSort("Status")}
                        >
                          Status{getSortArrow("Status")}
                        </th>
                      </tr>

                      {/* Filter Row */}
                      <tr>
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Sender"
                            value={filters.Sender}
                            onChange={(e) => handleFilterChange(e, "Sender")}
                          />
                        </th>
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search JobSiteNumber"
                            value={filters.JobSiteNumber}
                            onChange={(e) => handleFilterChange(e, "JobSiteNumber")}
                          />
                        </th>
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Region"
                            value={filters.Region}
                            onChange={(e) => handleFilterChange(e, "Region")}
                          />
                        </th>
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Company"
                            value={filters.Company}
                            onChange={(e) => handleFilterChange(e, "Company")}
                          />
                        </th>
                        {/* <th>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Driver"
                            value={filters.DriverName}
                            onChange={(e) =>
                              handleFilterChange(e, "DriverName")
                            }
                          />
                        </th> */}
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Template Name"
                            value={filters.RequestType}
                            onChange={(e) =>
                              handleFilterChange(e, "RequestType")
                            }
                          />
                        </th>
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search BOL"
                            value={filters.BOL}
                            onChange={(e) => handleFilterChange(e, "BOL")}
                          />
                        </th>
                        {/* <th className="text-center">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Create By"
                            value={filters.ModifiedByUser}
                            onChange={(e) =>
                              handleFilterChange(e, "ModifiedByUser")
                            }
                          />
                        </th> */}
                        <th className="text-center">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Updated Date"
                            value={filters.LastUpdated}
                            onChange={(e) =>
                              handleFilterChange(e, "LastUpdated")
                            }
                          />
                        </th>
                        <th className="text-center">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search Status"
                            value={filters.Status}
                            onChange={(e) => handleFilterChange(e, "Status")}
                          />
                        </th>
                      </tr>
                    </thead>

                    <tbody className="tbody-card">
                      {paginatedData.map((val, i) => (
                        <tr style={{ cursor: 'pointer' }} onClick={() => handleRowClick(val)} key={i}>
                          <td>{val.Sender}</td>
                          <td>{val.JobSiteNumber}</td>
                          <td>{val.Region}</td>
                          <td>{val.Company}</td>
                          {/* <td>{val.DriverName}</td> */}
                          <td>{val.RequestType}</td>
                          <td>{val.BOL}</td>
                          {/* <td>{val.ModifiedByUser}</td> */}
                          <td>{moment(val.LastUpdated).format("L")}</td>
                          <td className="text-center">{val.Status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                    <div className="pagination-heading mb-2">
                      <span className="lbl-pagination">
                        Showing{" "}
                        <span className="txt-num-bold">
                          {Math.min(
                            (currentPage - 1) * itemsPerPage + 1,
                            filteredAndSortedData.length
                          )}
                          –
                          {Math.min(
                            currentPage * itemsPerPage,
                            filteredAndSortedData.length
                          )}
                        </span>
                        {" "}
                        of <span className="txt-num-bold">{filteredAndSortedData.length}</span> Entries
                      </span>
                    </div>
                    {/* 
                 
                    {/*Pagination .............................................................................*/}
                    <>
                      <div className="d-flex flex-wrap gap-2 align-items-center">
                        {/* First Page Button */}
                        <button
                          className={`btn btn-sm btn-paginate-web ${currentPage === 1 ? "disabled" : ""}`}
                          onClick={() => setCurrentPage(1)}
                          disabled={currentPage === 1}
                        >
                          First
                        </button>

                        {/* Previous Page Button */}
                        <button
                          className={`btn btn-sm btn-paginate-web ${currentPage === 1 ? "disabled" : ""}`}
                          onClick={() => setCurrentPage(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Prev
                        </button>

                        {/* Page Numbers */}
                        {totalPages <= 6 ? (
                          // Show all pages if total pages is 6 or less
                          Array.from({ length: totalPages }, (_, i) => (
                            <button
                              key={i}
                              className={`btn btn-sm btn-paginate-web ${currentPage === i + 1 ? "btn-theme-btn" : ""
                                }`}
                              onClick={() => setCurrentPage(i + 1)}
                            >
                              {i + 1}
                            </button>
                          ))
                        ) : (
                          // Show truncated pagination with ellipsis for more than 6 pages
                          <>
                            {/* Always show first page */}
                            <button
                              className={`btn btn-sm btn-paginate-web ${currentPage === 1 ? "btn-theme-btn" : ""
                                }`}
                              onClick={() => setCurrentPage(1)}
                            >
                              1
                            </button>

                            {/* Show ellipsis after first page if current page is > 3 */}
                            {currentPage > 3 && <span className="px-2">...</span>}

                            {/* Show pages around current page */}
                            {[
                              currentPage - 1,
                              currentPage,
                              currentPage + 1,
                            ]
                              .filter(page => page > 1 && page < totalPages)
                              .map(page => (
                                <button
                                  key={page}
                                  className={`btn btn-sm btn-paginate-web ${currentPage === page ? "btn-theme-btn" : ""
                                    }`}
                                  onClick={() => setCurrentPage(page)}
                                >
                                  {page}
                                </button>
                              ))}

                            {/* Show ellipsis before last page if current page is < totalPages - 2 */}
                            {currentPage < totalPages - 2 && <span className="px-2">...</span>}

                            {/* Always show last page */}
                            <button
                              className={`btn btn-sm btn-paginate-web ${currentPage === totalPages ? "btn-theme-btn" : ""
                                }`}
                              onClick={() => setCurrentPage(totalPages)}
                            >
                              {totalPages}
                            </button>
                          </>
                        )}

                        {/* Next Page Button */}
                        <button
                          className={`btn btn-sm btn-paginate-web ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          onClick={() => setCurrentPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>

                        {/* Last Page Button */}
                        <button
                          className={`btn btn-sm btn-paginate-web ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          onClick={() => setCurrentPage(totalPages)}
                          disabled={currentPage === totalPages}
                        >
                          Last
                        </button>
                      </div>
                    </>
                    {/*Pagination .............................................................................*/}

                  </div>

                  {/* <div className='d-flex justify-content-end py-2'>
                    <div className='pagination-heading'><span className='lbl-pagination'>Showing 1-10 of 100 Entries</span></div>
                  </div> */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <MobileFooter></MobileFooter>
    </div>
  );
}

export default Home;
